import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  autoGenerate() {
    const addAllBtn = document.getElementById("addAllBtn")
    const removeAllBtn = document.getElementById("removeAllBtn")
    
    if (!addAllBtn || !removeAllBtn) return

    const mode = this.getGenerateMode()

    if (mode === "replace") {
      removeAllBtn.click()
      addAllBtn.click()
    } else {
      addAllBtn.click()
    }
    
    this.updateTimestamp()
  }

  reloadCandidates() {
    window.location.reload()
  }

  getGenerateMode() {
    const checked = document.querySelector('input[name="generateMode"]:checked')
    return checked ? checked.value : "replace"
  }

  updateTimestamp() {
    const updatedAt = document.getElementById("updatedAt")
    if (updatedAt) {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const h = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      updatedAt.textContent = `${y}/${m}/${day} ${h}:${min}`
    }
  }
}
